export default "__VITE_ASSET__Cvd9IYWo__"